import EmailAttachment from "@/domain/entities/emails/EmailAttachement";

/**
 * Image de la vignette d'une `MailTile` (vue mosaïque) : la plus grande PJ image NON inline.
 *
 * Les inline (images CID de signature ou des messages cités du fil) sont exclues — AB#1826. Pas de
 * filtre sur `preview` : elle est vide depuis AB#1727 et résolue à la demande par `MailTile`.
 */
const selectTileImageAttachment = (
    attachments: EmailAttachment[],
): EmailAttachment | undefined => {
    const images = attachments.filter(
        (attachment) => attachment.isImage() && !attachment.isEmbeddedInBody(),
    );
    if (images.length === 0) return undefined;

    return images.reduce((largest, current) =>
        current.size > largest.size ? current : largest,
    );
};

export default selectTileImageAttachment;
